import { render, staticRenderFns } from "./ZoomControls.vue?vue&type=template&id=6cf79bbe&scoped=true"
import script from "./ZoomControls.vue?vue&type=script&lang=ts"
export * from "./ZoomControls.vue?vue&type=script&lang=ts"
import style0 from "./ZoomControls.vue?vue&type=style&index=0&id=6cf79bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf79bbe",
  null
  
)

export default component.exports